// 热词管理
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/CommunityManager/getTopicList", data);

// 新增
export const add = (data) => http.post("/web/CommunityManager/addTopic", data);

// 删除
export const del = (data) => http.post("/web/CommunityManager/deleteTopic", data);

// 详情
export const detail = (data) => http.post("/web/CommunityManager/getTopicDetail", data);

// 编辑 
export const edit = (data) => http.post("/web/CommunityManager/updateTopic", data);
